import client from '@/graphql/client'
import ListBCObjects from '../../graphql/queries/ListBCObjects'
import CreateBCObject from '../../graphql/mutations/CreateBCObject'
import UpdateBCObject from '../../graphql/mutations/UpdateBCObject'
import DeleteBCObject from '../../graphql/mutations/DeleteBCObject'
import DeleteBoundedContext from '../../graphql/mutations/DeleteBoundedContext'

export const boundedContexts = {
  namespaced: true,
  state: {
    boundedContexts: {}
  },
  mutations: {
    createObject (state, payload) {
      if (!state.boundedContexts[payload.boundedContextId]) {
        state.boundedContexts[payload.boundedContextId] = [payload]
      } else {
        state.boundedContexts[payload.boundedContextId].push(payload)
      }
    },
    putObjects (state, payload) {
      if (payload.length > 0) {
        const boundedContextId = payload[0].boundedContextId
        state.boundedContexts[boundedContextId] = []

        payload.forEach((object) => {
          state.boundedContexts[boundedContextId].push(object)
        })
      }
    },
    updateObject (state, payload) {
      const objects = state.boundedContexts[payload.boundedContextId]
      if (!objects) {
        return
      }

      const objectIndex = objects.findIndex(o => o.id === payload.id)
      if (objectIndex === -1) {
        return
      }

      objects[objectIndex] = payload
    },
    deleteObject (state, payload) {
      const objects = state.boundedContexts[payload.boundedContextId]

      if (!objects) {
        return
      }

      const objectIndex = objects.findIndex(o => o.id === payload.id)
      if (objectIndex === -1) {
        return
      }

      state.boundedContexts[payload.boundedContextId].splice(objectIndex, 1)
    },
    clearBoundedContext (state, id) {
      state.boundedContexts[id] = null
    }
  },
  actions: {
    async createObject ({ commit, rootState }, { boundedContextId, filepath, contents, prompt, tags, draftContents }) {
      try {
        const res = await client.query({
          operationName: 'createBCObject',
          query: CreateBCObject,
          variables: {
            workflowId: rootState.workflow.workflow.id,
            input: {
              boundedContextId,
              filepath,
              contents,
              prompt,
              tags,
              draftContents
            }
          }
        })
        commit('createObject', res.createBCObject)
        return { ...res.createBCObject }
      } catch (e) {
        return {}
      }
    },

    async getObjectsFromServer ({ commit }, { boundedContextId, limit = 100 }) {
      try {
        let allObjects = []
        let nextToken = null

        do {
          const res = await client.query({
            operationName: 'listBCObjects',
            query: ListBCObjects,
            variables: {
              boundedContextId,
              limit,
              nextToken
            }
          })

          const items = res.listBCObjects.items || []
          allObjects = allObjects.concat(items)
          nextToken = res.listBCObjects.nextToken
        } while (nextToken)

        commit('putObjects', allObjects)
        return allObjects
      } catch (e) {
        return []
      }
    },

    async deleteBoundedContext ({ commit }, boundedContextId) {
      try {
        await client.query({
          operationName: 'deleteBoundedContext',
          query: DeleteBoundedContext,
          variables: { boundedContextId }
        })
        commit('clearBoundedContext', boundedContextId)
        return true
      } catch (e) {
        return false
      }
    },

    async updateObjectContents ({ commit, rootState }, object) {
      try {
        const res = await client.query({
          operationName: 'updateBCObject',
          query: UpdateBCObject,
          variables: {
            workflowId: rootState.workflow.workflow.id,
            id: object.id,
            input: {
              contents: object.contents,
              draftContents: object.draftContents,
              tags: object.tags || undefined
            }
          }
        })
        commit('updateObject', res.updateBCObject)
      } catch (e) {
        return null
      }
    },

    async deleteObject ({ commit, rootState }, object) {
      try {
        await client.query({
          operationName: 'deleteBCObject',
          query: DeleteBCObject,
          variables: {
            workflowId: rootState.workflow.workflow.id,
            id: object.id
          }
        })
        commit('deleteObject', object)
      } catch (e) {
        return null
      }
    }
  }
}
